var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-card"},[_c('router-link',{attrs:{"to":{ name: 'view-news', params: { id: _vm.news.id } }}},[_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.news.primary_image,"alt":""}})])]),_c('div',{staticClass:"name"},[_vm._v(" "+_vm._s(_vm.news.Title)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }